export const SITE_HEADER = {
    VIEW_AS_BTN: "view-as-btn",
    VIEW_AS: {
        COMPANY_LIST: "company-name",
        COMPANY_SEARCH: "company-search-field",
    },
    QUICK_ADD_BTN: "quick-add-button",
    AVATAR: "avatar",
    BULK_ACTIONS: {
        CONTAINER: "site-header-bulk-actions",
        MENU_BTN: "site-header-bulk-actions-menubtn",
        SHOW: "site-header-bulk-actions-show",
        HIDE: "site-header-bulk-actions-hide",
        REMOVE: "site-header-bulk-actions-remove",
    },
    START_ORDER_MODAL: {
        BUYER_SELECT_OPTION: "start-order-modal-buyer-select-option",
        CURRENCY_SELECT_OPTION: "start-order-modal-currency-select-option",
        CURRENCY_SELECT_MSRP_OPTION: "start-order-modal-currency-select-msrp-option",
        REP_SELECTOR: "start-order-modal-rep-selector",
        REP_SELECT_OPTION: "start-order-modal-rep-select-option",
        WAREHOUSE_SELECT_OPTION: "start-order-modal-warehouse-select-option",
        WAREHOUSE_SELECT_DROPDOWN: "start-order-modal-warehouse-select-dropdown",
        ORDER_TYPE_SELECT_OPTION: "start-order-modal-order-type-select-option",
        ORDER_TYPE_SELECT_DROPDOWN: "start-order-modal-order-type-select-dropdown",
        LOCATIONS_SELECTOR: "start-order-modal-locations-selector",
        LOCATIONS_SELECTOR_OPTION: "start-order-modal-locations-selector-option",
        LOCATIONS_SELECTOR_MULTI: "start-order-modal-locations-selector-multi",
    },
};
